import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class PrintErrorGuardService {
  private _printedErrors = new Map<string, number>(); 
  private readonly BLOCK_DURATION_MS = 60000; // 60 segundos

  /**
   * Verifica si se puede imprimir el error.
   * @param errorKey Clave única del error (id-pnr-msg)
   * @returns true si se puede imprimir, false si está bloqueado
   */
  canPrint(errorKey: string): boolean {
    const lastPrintTime = this._printedErrors.get(errorKey);
    
    if (!lastPrintTime) {
      return true;
    }
    
    const elapsed = Date.now() - lastPrintTime;
    
    if (elapsed > this.BLOCK_DURATION_MS) {
      this._printedErrors.delete(errorKey);
      return true;
    }
    
    return false;
  }

  /**
   * Marca el error como impreso.
   * @param errorKey Clave única del error
   */
  markAsPrinted(errorKey: string): void {
    this._printedErrors.set(errorKey, Date.now());
  }


  reset(): void {
    this._printedErrors.clear();
  }
}
